<template>
    <div class="btn-group">
        <div class="btn-group-title fz_28 bh bstart">
            <div class="b1">{{title}}</div>
            <div class="ico-delete bg-contain" @click="onDelClick" v-show="isDel"></div>
        </div>
        <div class="btn-group-list">
            <div v-for="(item,index) in data" :key="index" class="group-list-item list-item-inline">
                <van-button class="btn btn-history" @click="onBtnClick(item)">
                    <div class="bh bstart">
                        <div v-show="icoCls" :class="icoCls"></div>
                        <div class="overflow lh1_2">{{item[keyName]}}</div>
                    </div>
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GroupButton",
    props: {
        title: null,
        keyName: {
            type: String,
            default: "name"
        },
        isDel: {
            type: Boolean,
            default: false
        },
        icoCls: String,
        data: Array
    },
    data() {
        return {
            isHidden: true,
            isActivate: false
        };
    },
    methods: {
        onBtnClick(item) {
            this.$emit("btnClick", item);
        },
        onDelClick() {
            this.$emit("delClick");
        }
    }
};
</script>

<style scoped lang="scss">
.btn-group {
    padding: 60px 20px 0 20px;
    .btn-group-title {
        color: #000;
        padding: 0 10px 18px 10px;
    }
    .btn-group-list {
        .group-list-item {
            margin: 12px 10px;
            max-width: calc(33.3% -20px);
            .btn-history{
                max-width: 100%;
            }
            .lh1_2 {
                line-height: 1.2;
            }
        }
    }
}

.ico-delete {
    width: 28px;
    height: 28px;
    background-image: url("~@/assets/imges/ico/delete.png");
}
</style>

